import { NgModule, Component, OnInit, OnDestroy, Input, ElementRef, ViewChild } from '@angular/core'; // , Injector , Input, Output
import { SocketService } from '../../services/socket.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

// import { Subscription } from 'rxjs';
import { SharedPipeChatModule, TransferChancetalk } from '../../shared/shared.pipe.chat.module';
import { UserInfoModule } from '../../components/userInfo';
import { HttpService } from '../../services/http.service';
import { ChatService } from '../../services/chat.service';

// import { EventService } from '../../services/event.service';
import { ToasterService } from '../../services/toaster.service';
import { AuthService } from '../../services/auth.service';

import { Nl2brPipeModule } from '../../pipes/nl2br.pipe';

@Component({
    selector: 'chance-talk-view',
    template: `
        <!-- chat_box -->
        <div class="chat_box">
            <div #scrollMe class="chat_chance scroll" [ngStyle]="{height: (dynamicHeight) + 'px'}" >
                <dl *ngFor="let message of messages">
                    <dd *ngIf="message.user.mb_id !== me.mb_id">
                        <img [alt]="message.user.mb_id" appIsProfileimg class="profileImgS3">
                        <p>{{message.user.mb_nick}}</p>
                        <em [innerHTML]="message.msg | nl2br"><span>{{message.created | transferChancetalk}}</span></em>
                    </dd>
                    <dt *ngIf="message.user.mb_id === me.mb_id">
                        <em>{{message.msg}}<span>{{message.created | transferChancetalk}}</span></em>
                    </dt>
                </dl>
            </div>
            <div class="chat-input" *ngIf="viewMode!='preview'">
                <div class="input">
                    <mat-form-field class="w100p" floatLabel="never">
                        <input matInput class="w100p" [(ngModel)]="data.message" name="message" placeholder="이곳에 메시지를 입력해주세요." required>
                    </mat-form-field>
                </div>
                <button mat-button aria-label="찬스톡" class="mat-mat-button mat-button"  (click)="sendMessage();">전송</button>
            </div>
        </div>
`
})
export class ChanceTalkViewComponent implements OnInit, OnDestroy {
    private ngUnsubscribe = new Subject();
    // showNum = 0;
    data: any = {};
    messages = []; // 채팅 내용;
//    data: any = {message: ''};
    connection = new Array();
    dynamicHeight = 300;
    sockConnection = new Array();
//    footerObj: any;
    setData: any = {lists: {}};
    roomInfo: any;
    chatId = '';
    mbId: number;
    viewMode: string;
    participants: any;
    me: any = {mb_id: ''};
    transferChancetalkFilter: any;
    // private subscription: Subscription; // 채팅창 관련 다양한 이벤트를 이곳에서 받는다.

    // @ViewChild('scrollMe') private myScrollContainer: ElementRef;
    @ViewChild('scrollMe', {static: true}) myScrollContainer: ElementRef;

    @Input() set resizeObject(resizeData: {edges: any, rectangle: any }) {
        if (!resizeData.rectangle) {
            return;
        }

        const  rectangleHeight = resizeData.rectangle.height - 78;
        this.dynamicHeight = rectangleHeight;
    }

    @Input() set selectedChatIndex(index: number) {
        console.log('ChanceTalkView selectedChatIndex');
        console.log('index:' + index);
        if (index === 1) {
            this.socketService.Emit('leave_curent_room', '@basic1');
            this.socketService.removeListener('publicChat'); // 공개채팅방과 연결된 리스너 삭제
            this.socketService.removeListener('chanceTalkView'); // 찬스톡 상세보기 관련 리스너 삭제
        }
    }

    /**
     * {    type: 'chanceTalkView',chat_id: chat_id, view_mode: 'reOpen'} 닫힌 창을 활성
     * {    type: 'chanceTalkView',chat_id: chat_id, view_mode: 'preview'} 미리보기로 진입
     * {    type: 'chanceTalkView',chat_id: chat_id, view_mode: 'chancetalk'} 일반적인 진입
     * {    type: 'chanceTalkView', mb_id: this.user.mb_id, view_mode: 'direct'} 외부에서 직접 진입
     */
    @Input() set chancetalkView(obj: any) {

        if (typeof obj !== 'undefined') {
            this.viewMode = obj.view_mode;
            if (obj.view_mode === 'direct') { // 직접 접근일 경우 현재 mb_id를 통해 chat_id를 구한다.
                this.chatId = '';
                this.mbId = obj.mb_id;
            } else {
                this.chatId = obj.chat_id;
            }


        }

        // this.socketService.leaveRoom('chanceTalkView'); // 찬스톡에 의해 세팅된 각각의 방을 떠난다.
        // 기존
        this.init();
    }

    constructor(
        private socketService: SocketService,
        private http: HttpService,
        private chatService: ChatService,
        private authService: AuthService,
        private toasterService: ToasterService,
    ) {
        this.authService.mustLoggedIn();
        this.me = authService.getUser();

        this.transferChancetalkFilter = new TransferChancetalk();
    }

    ngOnInit() {
        // console.log('ngOnInit');
    }

    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }

    private init() {
        // this.chatService.setChatRoom(obj);
        this.roomInfo = this.chatService.getChatRoom();
        if (this.chatId) {

            // 현재 페이지 추가
            this.socketService.addRoom(this.chatId);
            // 현재 페이지에 대한 내용 불러오기
            this.socketService.Emit('refreshChatHistory', {chatRoom : this.chatId}); // socket.on('chatList', function (req) { 에서 받아서 처리
            this.get_participants_lists();

            // 현재까지 읽지 않은 대화 내용을 0으로 처리한다.
            const params = {chancetalk_room_id: this.chatId, flag: 'unset'};
            this.http.post({url: 'chat/update-unread-cnt', params}).then(() => {
                this.chatService.setUnreadCntAll(() => {});
            });
        } else if (this.mbId) { // 회원아이디만 있을 경우 room id를 가지고 온다.
            this.get_room_id(() => {
                this.get_participants_lists();
            });
        }


        // 채팅 내용 히스토리 받기 시작
        this.socketService.sockConnection.chanceTalkView.push(
            this.socketService.On('chatList')
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(obj => {
                const req: any = obj[0];
                req.reverse();

                this.messages = [];
                // for (let i = 0; i < req.length; i++) {
                for (const ele of req) {
                    this.messages.push(JSON.parse(ele));
                }

                if (this.roomInfo !== null && typeof (this.roomInfo.data) !== 'undefined') {
                //    const unread_cnt = this.roomInfo.data.unread_cnt;
                //    const readHere = req.length - unread_cnt;
                    // jQuery('.chat_chance > dl').eq(readHere).before('<div class="before_place">여기까지 읽으셨습니다.</div>');
                }
                this.scrollToBottom();
            })
        );

        this.socketService.sockConnection.chanceTalkView.push(
            this.socketService.On('receiveMessage')
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(obj => {
                const req: any = obj[0];
                if (typeof (req.chancetalk_room_id) === 'undefined') {
                    return;
                }

                if (req.chancetalk_room_id !== this.chatId) {
                    return;
                }

                // 현재까지 읽지 않은 대화 내용을 0으로 처리한다.
                const params = {chancetalk_room_id: this.chatId, flag: 'unset'};

                this.http.post({url: 'chat/update-unread-cnt', params});

                this.messages.push(req);

                this.scrollToBottom();
            })
        );
    }

    // 방에 참여하는 대화상대 리스트 가져오기
    private get_participants_lists() {
        this.http.get({url: 'chat/participants-lists', params: {room_id: this.chatId}}).then((obj) => {
            console.log('get_participants_lists');
            console.log(obj);
            if (obj.result === false) {
                this.toasterService.showToaster('error', obj.message);
            } else {
                this.participants = obj.participants;
            }
        });
    }

    // 룸아이디 구하기
    private get_room_id(callback: () => void) {
        this.http.get({url: 'chat/get-room-id', params: {friend_id: this.mbId}}).then((obj) => {
            if (obj.room_id) {
                this.chatId = obj.room_id;
                this.socketService.Emit('add_page', {page: this.chatId});
                this.socketService.Emit('refreshChatHistory', {chatRoom : this.chatId}); // socket.on('chatList', function (req) { 에서 받아서 처리
                callback();
            }
        });
    }
/*
    private message_template(obj) {
        let chat_message = '';
            chat_message += '<dl>';
            if (obj.user.mb_id !== this.me.mb_id) {
                chat_message += '    <dd>';
                chat_message += '            <p>' + obj.user.mb_nick + '</p>';
                chat_message += '            <em>' + this.nl2brFilter.transform(obj.msg) + '<span>' + this.transferChancetalkFilter.transform(obj.created) + '</span></em>';
                chat_message += '    </dd>';
            } else {
                chat_message += '    <dt>';
                chat_message += '        <em>' + this.nl2brFilter.transform(obj.msg) + '<span>' + this.transferChancetalkFilter.transform(obj.created) + '</span></em>';
                chat_message += '    </dt>';
            }
            chat_message += '</dl>';

            return chat_message;
    };
*/


    /**
     * 메시지 전송하기
     */
    sendMessage() {
        if (this.data.message === '') {
            return;
        }

        this.http.get({url: 'mypage/chat_prohibit_status'}).then((obj) => {
            if (obj.result === false) {
                this.toasterService.showToaster('error', obj.message);
            } else {
                if (this.chatId === '') { // 처음으로 접근했을 경우
                    this.http.get({url: 'chat/create_chancetalk_room', params: {friend_id: this.mbId}}).then((res) => {
                        if (res.result === false) {
                            this.toasterService.showToaster('error', res.message);
                        } else {
                            this.chatId = res.room_id;
                            this.socketService.Emit('add_page', {page: res.room_id});
                            this.send_msg_chancetalk({chatRoom : this.chatId, msg : this.data.message, chancetalk_room_id: this.chatId, chancetalk_participants: this.participants});
                        }
                    });
                } else {
                    this.send_msg_chancetalk({chatRoom : this.chatId, msg : this.data.message, chancetalk_room_id: this.chatId, chancetalk_participants: this.participants});
                }
            }
        });
        // $ionicScrollDelegate.scrollBottom(true);
    }

    private send_msg_chancetalk(obj: any) {
        this.socketService.Emit('setMessage', obj);
        delete this.data.message;

        // 상대편의 메시지 읽지받은 사람들의 읽지 않음 갯수 업데이트
        const params = {chancetalk_room_id: obj.chancetalk_room_id, flag: 'set'};
        this.http.post({url: 'chat/update-unread-cnt', params});
    }

/*
    private send() {
      const payload = {
        type: 'my message type',
        text: 'my message text'
    };
      this.eventService.broadcast('chancetalk', payload);
    }
*/
    private scrollToBottom(): void {
        setTimeout(() => {
            try {
                this.myScrollContainer.nativeElement.scrollTop = (this.myScrollContainer.nativeElement.scrollHeight + 120);
            } catch (err) { }
        }, 200);
    }
}

@NgModule({
    declarations: [
        ChanceTalkViewComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        MatFormFieldModule,
        MatInputModule,
        SharedPipeChatModule,
        UserInfoModule,
        Nl2brPipeModule
    ],
    exports: [
        ChanceTalkViewComponent
    ]
})

export class ChanceTalkViewModule {}
